import React from 'react';
import { BrainIcon, ZapIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function MechanismSection() {
  return <section className="relative z-10 py-24 px-4 bg-gradient-to-b from-transparent via-blue-900/10 to-transparent" data-id="element-81">
      <div className="max-w-4xl mx-auto" data-id="element-82">
        <FadeIn data-id="element-83">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-84">
            La Solución:{' '}
            <span className="text-blue-400" data-id="element-85">
              Protocolo de Vaciado Mental Somático
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} className="glass-card box-glow p-8 md:p-12 border-blue-500/30 relative overflow-hidden" data-id="element-86">
          {/* Decorative background glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-blue-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-87"></div>

          <div className="relative z-10" data-id="element-88">
            <p className="text-xl md:text-2xl font-serif text-white text-center mb-10 leading-relaxed" data-id="element-89">
              La clave no es "intentar dormir", es aplicar el{' '}
              <strong className="text-blue-300 font-normal italic" data-id="element-90">
                Protocolo de Vaciado Mental Somático
              </strong>
              .
            </p>

            <div className="space-y-8" data-id="element-91">
              <div className="flex gap-4 md:gap-6" data-id="element-92">
                <div className="flex-shrink-0 mt-1" data-id="element-93">
                  <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center border border-blue-500/40" data-id="element-94">
                    <BrainIcon className="w-5 h-5 text-blue-400" data-id="element-95" />
                  </div>
                </div>
                <p className="text-gray-300 text-lg leading-relaxed" data-id="element-96">
                  Este sistema hackea tu biología mediante la{' '}
                  <strong className="text-white" data-id="element-97">
                    descarga neuro-cognitiva
                  </strong>{' '}
                  (pasar el estrés de las neuronas al papel) y el enfriamiento
                  térmico del núcleo corporal.
                </p>
              </div>

              <div className="flex gap-4 md:gap-6" data-id="element-98">
                <div className="flex-shrink-0 mt-1" data-id="element-99">
                  <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center border border-amber-500/40" data-id="element-100">
                    <ZapIcon className="w-5 h-5 text-amber-400" data-id="element-101" />
                  </div>
                </div>
                <p className="text-gray-300 text-lg leading-relaxed" data-id="element-102">
                  Engañamos a tu sistema nervioso para que crea que todos los
                  "problemas" han sido archivados y que es seguro bajar la
                  guardia.{' '}
                  <strong className="text-white" data-id="element-103">
                    Es un interruptor manual para un cerebro que se olvidó de
                    cómo apagarse solo.
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}